/* eslint-disable  */
import React from 'react';
import { Button, Box, CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

  commonBtn: {
    borderRadius: 0,
    padding: '0.75rem 1.5rem',
  }
}));

export default function BtnWithLoader(props) {
  const classes = useStyles();
  const {
    id,
    onClick,
    disabled,
    className,
    variant,
    size,
    color,
    fullWidth,
    isLoading,
    loadingLabel,
    label,
    type = 'button',
    disabledColor,
    ...restProps
  } = props;
  return (
    <Button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${className} rounded`}
      variant={variant}
      size={size}
      color={color}
      fullWidth={fullWidth}>
      {isLoading ? (
        <Box display="flex" alignItems="center" component="span">
          <Box display="inline-flex" component="span" marginRight={0.75}>
            <CircularProgress component="span" color="inherit" size={16} />
          </Box>{' '}
          {loadingLabel}
        </Box>
      ) : (
        <Box display="flex" alignItems="center" component="span">
          {/* {typeof render !== 'function' ? label : render()} */}
          {restProps.icon ? (
            <Box display="inline-flex" component="span" marginRight={0.75}>
              {restProps.icon}
            </Box>
          ) : (
            false
          )}
          {label}
        </Box>
      )}
    </Button>
  );
}
